import { Component, ViewChild } from '@angular/core';
import { Nav, Platform,  Events, LoadingController, NavController, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import {Storage } from '@ionic/storage';
import { Network } from '@ionic-native/network';

import * as page from '../pages/pages';
import { BadgesPage, LoginPage } from '../pages/pages';
import { Deeplinks } from '@ionic-native/deeplinks';
import { URLSearchParams } from '@angular/http';

@Component({
	templateUrl: 'app.html'
})

export class MyApp {
	@ViewChild(Nav) nav: Nav;

	rootPage: any = page.LoginPage;
	showLogout: boolean = false;

	pages: Array<{ title: string, icon:string, component: any }>;

	constructor(
		public storage: Storage,
		public platform: Platform, 
		public statusBar: StatusBar,
		public splashScreen: SplashScreen,
		private loadingCtrl: LoadingController,
		private iab: InAppBrowser,
		public deeplinks: Deeplinks,
		public alertController: AlertController) {
		this.initializeApp();
	}

	initializeApp() {
		this.platform.ready().then(() => {
			// Okay, so the platform is ready and our plugins are available.
			// Here you can do any higher level native things you might need.
			this.statusBar.styleDefault();
			this.splashScreen.hide();

			try {
				let someParam = this.platform.getQueryParam('code'); 
				console.log(someParam);
				if (someParam != null && someParam != undefined)
				{
					if (someParam.length > 0) {
						this.nav.push(LoginPage, {
							code: someParam
						});
					}
				}
			} catch (e) {
				console.log(e);
			}

			this.deeplinks.routeWithNavController(this.nav, {
				"/login/:code": LoginPage 
			}).subscribe(match => {
				// 
			}, nomatch => {
				// 
			});

			//Set root page
			this.storage.get('accessToken').then(data => {
				if(data != null && data != undefined){
					var expiry = this.storage.get("tokenExpiry")
					.then((expiresAt) => {
						var expired = Date.now() > expiresAt;
						if(expired == true){
							this.rootPage = LoginPage;
						}
						else{
							this.rootPage = BadgesPage;
							this.showLogout = true;
						}
					  })
					  .catch((err) => {
						this.rootPage = LoginPage;
					  });					
				}
				else{
					this.rootPage = LoginPage;
				}
			});

			if (localStorage.getItem("accepted-terms") == null) {
			  this.presentTermsAndConditions();
			}
		});
	}
	
	async presentTermsAndConditions() {
		const alert = await this.alertController.create({
		  title: 'Terms & Conditions',
		  message: '<p>This mobile application is protected by worldwide copyright laws and treaties.</p>' +
		  '<p>Copyright in the pages of this application, in the screens displaying the pages and in the information and material contained therein and their arrangement is owned by eCom Scotland Ltd, unless otherwise indicated.</p>' +
		  '<p>Copyright eCom Scotland 2000 - 2020.</p>' +
		  '<p>All rights reserved</p>' + 
		  '<p>Permission is granted for your use of copyright material the limited purposes of:</p>' +
		  '<ul>' +
		  '<li>printing in hard copy form portions of the content of this application for maintaining your own personal records;</li>' +
		  '<li>downloading the pages on this application for viewing in a compatible web browser; and</li>' +
		  '<li>storing the pages of this application in a cache or other temporary retrieval system for the sole purpose of personal viewing off-line.</li>'+
		  '</ul>'+
		  '<p>Should you wish to use the copyright material for other purposes please contact our Marketing Manager for permission, at info@ecomscotland.com.</p>' +
		  '<p>eCom Scotland is committed to responsible data management and is listed on the Data Protection Register in accordance with UK Data Protection legislation.</p>' +
		  '<p>For further information on our use of personal data see eCom’s Privacy Policy.</p>' +
		  '<p>Links are permitted to site pages. We request that any linking or framing to this application is made only with the prior written consent of eCom Scotland.</p>' +
		  '<p>Please contact our Managing Manager, at info@ecomscotland.com for details. eCom Scotland expressly prohibits the use of this application by you for any purpose which is unlawful in the United Kingdom.</p>'+
		  '<p>By accessing this site you agree to comply with eCom’s Acceptable Use Policy. eCom Scotland does not represent or warrant that the information accessible via or on this application is accurate, current or complete. Where it is informed of inaccuracies or errors eCom Scotland shall endeavour to correct the contents of this application.</p>',
		  buttons: [
			{
			  text: 'Disagree',
			  role: 'cancel',
			  cssClass: 'secondary',
			  handler: (err) => {
				this.platform.exitApp();
				window.close();
			  }
			}, {
			  text: 'Agree',
			  handler: () => {
				localStorage.setItem("accepted-terms", "true");
			  }
			}
		  ]
		});
	
		await alert.present();
	  }

	logout() {
		let loader = this.loadingCtrl.create();
		loader.present().then(() => {
			this.storage.remove('username');
			this.storage.remove('accessToken');
			this.storage.remove('currentRole');
			this.storage.remove('userId');
			this.storage.remove('name');
			this.nav.setRoot(LoginPage);
			this.showLogout = false;
			loader.dismiss().catch(err => console.log(err));
		}).catch(
			function () {
				loader.dismiss().catch(err => console.log(err))
				this.showLogout = false;
			});
	}

	openPage(page) {
		if (page.title == "Visit Website"){
			this.iab.create("http://ecomscotland.com/", '_system');
		}else{
			this.nav.push(page.component);
		}
	}
	
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts